
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderWebhookDialog extends Serenity.EntityDialog<OrderWebhookRow, any> {
        protected getFormKey() { return OrderWebhookForm.formKey; }
        protected getIdProperty() { return OrderWebhookRow.idProperty; }
        protected getLocalTextPrefix() { return OrderWebhookRow.localTextPrefix; }
        protected getNameProperty() { return OrderWebhookRow.nameProperty; }
        protected getService() { return OrderWebhookService.baseUrl; }
        protected getDeletePermission() { return OrderWebhookRow.deletePermission; }
        protected getInsertPermission() { return OrderWebhookRow.insertPermission; }
        protected getUpdatePermission() { return OrderWebhookRow.updatePermission; }

        protected form = new OrderWebhookForm(this.idPrefix);

    }
}